import { combineReducers } from 'redux'
import {
  ACL_LIST_ERROR, ACL_LIST_LOADING, ACL_LIST_SUCCESS,
  ACL_SET_ERROR, ACL_SET_LOADING, ACL_SET_SUCCESS
} from './constant'

const aclListError = (state = false, acl) => {
  switch (acl.type) {
    case ACL_LIST_ERROR:
      return acl.aclListError
    default:
      return state
  }
}

const aclListLoading = (state = false, acl) => {
  switch (acl.type) {
    case ACL_LIST_LOADING:
      return acl.aclListLoading
    default:
      return state
  }
}

const aclListSuccess = (state = false, acl) => {
  switch (acl.type) {
    case ACL_LIST_SUCCESS:
      return acl.aclListSuccess
    default:
      return state
  }
}

const aclSetError = (state = false, acl) => {
  switch (acl.type) {
    case ACL_SET_ERROR:
      return acl.aclSetError
    default:
      return state
  }
}

const aclSetLoading = (state = false, acl) => {
  switch (acl.type) {
    case ACL_SET_LOADING:
      return acl.aclSetLoading
    default:
      return state
  }
}

const aclSetSuccess = (state = false, acl) => {
  switch (acl.type) {
    case ACL_SET_SUCCESS:
      return acl.aclSetSuccess
    default:
      return state
  }
}

const acls = (state = [], acl) => {
  switch (acl.type) {
    case ACL_LIST_SUCCESS:
      return acl.acl
    default:
      return state
  }
}

const aclReducer = combineReducers({

  acls,

  aclListError,
  aclListLoading,
  aclListSuccess,

  aclSetError,
  aclSetLoading,
  aclSetSuccess,
})

export default aclReducer
